module.exports = __webpack_public_path__ + "9c6e1d5296420b05a4f7c79ee0384573.gif";